"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageSummaryUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var utils_1 = require("../../../components/TopStats/utils");
var copy_1 = require("../../../copy");
var utils_2 = require("../../../utils");
var UsageSummaryUI_styled_1 = require("./UsageSummaryUI.styled");
var components_1 = require("./components");
var UsageSummaryUI = function (_a) {
    var _b, _c;
    var usage = _a.usage, date = _a.date;
    var _d = (0, core_1.useComponents)(), SummaryCard = _d.SummaryCard, Heading4 = _d.Heading4, Row = _d.Row, Col = _d.Col;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var combinedUsage = (0, utils_2.generateCombinedUsageForDatePeriod)('monthly', usage, date);
    var totalElecCost = (0, utils_1.sumElecCost)(combinedUsage);
    var totalGasCost = (0, utils_1.sumGasCost)(combinedUsage);
    var totalElecConsumption = (0, utils_1.sumElecConsumption)(combinedUsage);
    var totalGasConsumption = (0, utils_1.sumGasConsumption)(combinedUsage);
    var dualFuel = totalElecConsumption !== null && totalGasConsumption !== null;
    var singleFuelGas = totalElecConsumption === null && totalGasConsumption !== null;
    var singleFuelElec = totalElecConsumption !== null && totalGasConsumption === null;
    var totalCost = (0, utils_1.sumWithNull)(totalElecCost, totalGasCost);
    var totalConsumption = (0, utils_1.sumWithNull)(totalElecConsumption, totalGasConsumption);
    var isSingleFuelWithoutCostData = (singleFuelElec && !totalElecCost) || (singleFuelGas && !totalGasCost);
    if ((!totalElecConsumption && !totalGasConsumption) ||
        isSingleFuelWithoutCostData ||
        (dualFuel && (!totalElecCost || !totalGasCost))) {
        return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.USAGE_INFO, properties: (_b = {},
                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                _b.status = 'error',
                _b.reason = !totalElecConsumption && !totalGasConsumption
                    ? 'noFuels'
                    : 'missingCostData',
                _b) },
            react_1.default.createElement(components_1.NoDataError, { "data-testid": "usage-no-cost-data" })));
    }
    var formattedLastMonth = (0, date_fns_1.format)(date, 'MMM yyyy');
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.USAGE_INFO, properties: (_c = {},
            _c[core_1.INTERNAL_EVENT_FLAG] = true,
            _c.isDualFuel = dualFuel,
            _c.status = 'ok',
            _c) },
        react_1.default.createElement(SummaryCard, { "data-testid": "usage-info", heading: react_1.default.createElement(Copy, { copyKey: "summaryTitle" }), subtitle: formattedLastMonth, icon: "usage", footer: react_1.default.createElement(components_1.Footer, null) },
            react_1.default.createElement(UsageSummaryUI_styled_1.StyledInfoContent, null,
                react_1.default.createElement(Heading4, { as: "h3" }, dualFuel && (react_1.default.createElement(react_1.default.Fragment, null,
                    "Total:",
                    ' ',
                    totalCost ? "".concat((0, core_1.major2DP)((0, core_1.majorToMinor)(totalCost)), " ") : null,
                    react_1.default.createElement(UsageSummaryUI_styled_1.StyledHeadingPlainText, null,
                        totalConsumption && totalConsumption.toFixed(2),
                        " kWh")))),
                react_1.default.createElement(Row, { isNested: true },
                    totalElecConsumption && (react_1.default.createElement(Col, { span: 6 },
                        react_1.default.createElement(components_1.FuelData, { supplyType: "Electricity", consumption: totalElecConsumption, cost: totalElecCost }))),
                    totalGasConsumption && (react_1.default.createElement(Col, { span: 6 },
                        react_1.default.createElement(components_1.FuelData, { supplyType: "Gas", consumption: totalGasConsumption, cost: totalGasCost })))),
                react_1.default.createElement(Copy, { copyKey: "summarySmallPrint" })))));
};
exports.UsageSummaryUI = UsageSummaryUI;
